import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { paths } from '@shared/config';

export function BackToSignInLink() {
  const { t } = useTranslation();
  return (
    <Link
      to={paths.auth}
      className="inline-flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap text-xs text-muted transition-colors hover:text-fg"
    >
      <span aria-hidden className="font-mono text-[14px]">←</span>
      <span>{t('auth.forgot.backToSignIn')}</span>
    </Link>
  );
}
